var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body flex flex_gap_10" }, [
        _c("div", [
          _c("label", [_vm._v("Период")]),
          _vm._v(" "),
          _c("div", [_c("DateRangePicker", { ref: "range" })], 1),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("label", [_vm._v("Дивизионы")]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "Multiselect",
                {
                  attrs: {
                    options: _vm.getDivision(),
                    multiple: true,
                    "close-on-select": false,
                    "clear-on-select": false,
                    "preserve-search": true,
                    "custom-label": _vm.getDivisionOption,
                    placeholder: "Выберите дивизионы",
                    label: "title",
                    "track-by": "id",
                  },
                  model: {
                    value: _vm.selectedDivisions,
                    callback: function ($$v) {
                      _vm.selectedDivisions = $$v
                    },
                    expression: "selectedDivisions",
                  },
                },
                [
                  _c("template", { slot: "noResult" }, [
                    _vm._v("Дивизион не найден"),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex-grow-1 text-right" },
          [
            _c("LoadingButton", {
              attrs: {
                title: "Показать",
                type: "button",
                loading: _vm.btnLoading,
                color: _vm.$constants.LOADING_COLOR,
                onClick: () => _vm.getRecords(),
                className: "btn btn-outline-info",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.btnLoading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          !_vm.btnLoading && Object.keys(_vm.records).length
            ? _c("div", [
                _c(
                  "table",
                  { staticClass: "table mt-0 table-hover table-sm" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _vm._l(_vm.records, function (group, id, i) {
                          return [
                            _c("tr", [
                              _c(
                                "td",
                                { attrs: { rowspan: group.length + 1 } },
                                [_vm._v(_vm._s(i + 1))]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { attrs: { rowspan: group.length + 1 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$AllDivisions[group[0].division_id]
                                        ?.title
                                    )
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(group, function (g) {
                              return _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      g.courier?.short_name ?? g.courier?.name
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(g.total_orders))]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(Math.round(g.total_salary))),
                                ]),
                              ])
                            }),
                          ]
                        }),
                      ],
                      2
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Дивизион")]),
        _vm._v(" "),
        _c("th", [_vm._v("курьер")]),
        _vm._v(" "),
        _c("th", [_vm._v("заявок")]),
        _vm._v(" "),
        _c("th", [_vm._v("зп")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }